import { useTranslation } from "react-i18next";
import Input from "../../../../GlobalComponents/Input";
import WindowWidthResponziveInfo from "./WindowWidthResponziveInfo";

const SectionResponziveSettings = ({size,formData,OnChange}) => {

    const {t} = useTranslation();

    return (
        <>
            <WindowWidthResponziveInfo size={size} />
            
            <div className="row">
                <div className="col-50">
                    <div className="form-group">
                        <label>{t("PaddingTop")}</label>
                        <Input 
                            type = "number"
                            name = {"pt" + size}
                            value = {formData["pt" + size]}
                            OnChange = {(e) => OnChange(e)}
                        />
                    </div>
                </div>
                <div className="col-50">
                    <div className="form-group">
                        <label>{t("PaddingBottom")}</label>
                        <Input 
                            type = "number"
                            name = {"pb" + size}
                            value = {formData["pb" + size]}
                            OnChange = {(e) => OnChange(e)}
                        />
                    </div>
                </div>
                <div className="col-50">
                    <div className="form-group">
                        <label>{t("PaddingLeft")}</label>
                        <Input 
                            type = "number"
                            name = {"pl" + size}
                            value = {formData["pl" + size]}
                            OnChange = {(e) => OnChange(e)}
                        />
                    </div>
                </div>
                <div className="col-50">
                    <div className="form-group">
                        <label>{t("PaddingRight")}</label>
                        <Input 
                            type = "number"
                            name = {"pr" + size}
                            value = {formData["pr" + size]}
                            OnChange = {(e) => OnChange(e)}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionResponziveSettings;